import React from 'react';
import { withStyles } from '@material-ui/core';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';

import styles from './HeaderWithYearPicker.styles';
import HeaderWithYearPicker from './HeaderWithYearPicker';

export default withStyles(styles)(HeaderWithYearPicker) as React.ComponentClass<ReactDatePickerCustomHeaderProps>;
